import { http } from './index'
import type { EmployeeStatisticsSettingsPatch } from '@/types'

export async function getSettings() {
    return await http.get<any>(`/api/settings/global/`)
}

export async function editSettings(data: any) {
    return await http.patch<any>(`/api/settings/global/`, data)
}

export async function getEmployeeStatisticsSettings() {
    return await http.get<any>(`/api/settings/employee-statistics/`)
}

export async function editEmployeeStatisticsSettings(data: EmployeeStatisticsSettingsPatch) {
    return await http.patch<any>(`/api/settings/employee-statistics/`, data)
}

export async function getLunch() {
    return await http.get<any>(`/api/lunch-break-rules/`)
}

export async function addLunch(data:any) {
    return await http.post<any>(`/api/lunch-break-rules/`, data)
}

export async function editLunch(id:string, data:any) {
    return await http.patch<any>(`/api/lunch-break-rules/${id}/`, data)
}

export async function deleteLunch(id:string) {
    return await http.delete<any>(`/api/lunch-break-rules/${id}/`)
}

export async function getRoles() {
    return await http.get<any>(`/api/roles/`)
}

export async function saveChangedRole(id:string|number, data:any) {
    return await http.patch<any>(`/api/roles/${id}/`, data)
}
